import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from 'components/ui/label';
import { RadioGroup, RadioGroupItem } from 'components/ui/radio-group';
import { cn } from 'lib/utils';
import PhoneOTPSignin from './PhoneOTPSignin';
import EmailOTPSignin from './EmailOTPSignin';
import { Button } from 'components/ui/button';

interface OTPLoginFormProps {
  onSigninChange: () => void;
}

export default function OTPLoginForm({ onSigninChange }: OTPLoginFormProps) {
  const { t } = useTranslation();

  const [otpChannel, setOtpChannel] = useState<'email' | 'phone'>('email');

  const channels = [
    { name: t('email'), value: 'email', isSelected: otpChannel === 'email' },
    {
      name: t('phone_number'),
      value: 'phone',
      isSelected: otpChannel === 'phone',
    },
  ];

  return (
    <div className='w-full px-8 sm:w-2/3'>
      <RadioGroup
        defaultValue='email'
        className='flex items-center gap-x-6'
        value={otpChannel}
        onValueChange={(value: 'email' | 'phone') => setOtpChannel(value)}
      >
        {channels.map((channel) => (
          <ChannelRadio {...channel} key={channel.value} />
        ))}
      </RadioGroup>

      <div className='mt-6 mb-1'>
        {otpChannel === 'email' && <EmailOTPSignin />}
        {otpChannel === 'phone' && <PhoneOTPSignin />}
      </div>

      <div className='flex justify-center'>
        <Button
          type='button'
          variant='link'
          className='font-medium text-gray-700'
          onClick={onSigninChange}
        >
          {t('signin_by_password')}
        </Button>
      </div>
    </div>
  );
}

function ChannelRadio({
  name,
  value,
  isSelected,
}: {
  name: string;
  value: string;
  isSelected: boolean;
}) {
  return (
    <div className='flex items-center space-x-2'>
      <RadioGroupItem value={value} id={value} />
      <Label
        htmlFor={value}
        className={cn('text-gray-800', isSelected && 'text-primary')}
      >
        {name}
      </Label>
    </div>
  );
}
